import { useSelector } from "react-redux";

import createSignalsManagementViewModel from "../models/view/signals-management/factory";
import type SignalsManagementViewModel from "../models/view/signals-management/SignalsManagementViewModel";
import signalsService from "../services/signalsService";
import { selectSignalsSource } from "../store/selectors";

import { usePermanentUISignalsGroupedByType } from "./useUISignals";

export const useSignalsManagementViewModel = (): Readonly<SignalsManagementViewModel> => {
    const uiSignalsGroupedByType = usePermanentUISignalsGroupedByType();
    const signalSource = useSelector(selectSignalsSource);

    return createSignalsManagementViewModel({
        signalsService,
        signalsByType: uiSignalsGroupedByType,
        signalSource: signalSource,
    });
};
